export default __webpack_public_path__ + "static/media/dermatology.e5f82516.png";